import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "title": "About",
  "icon": "M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`About GatStats`}</h1>
    <p>{`First and foremost GatStats is a `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/themes/what-are-gatsby-themes/"
      }}>{`Gatsby theme`}</a>{`, its underpinned by `}<a parentName="p" {...{
        "href": "https://theme-ui.com/"
      }}>{`theme-ui`}</a>{` making updating theme styles a breeze.`}</p>
    <p>{`If you require larger changes GatStats fully supports Gatsby themes `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/blog/2019-04-29-component-shadowing/"
      }}>{`Component Shadowing`}</a>{`.`}</p>
    <p>{`If you're looking to spin up a blog GatStats will do that just fine but GatStats also provides and exposes a little more information for your readers.`}</p>
    <p>{`The "Dashboard" comes with three data visulisations which inspect your file system and frontmatter to determine how often you post, which tags you use the most and which days of the week you generally post on.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      